import { actionCreator } from '../../../helpers/actionCreator';

export const GET_ONBOARDING_ALL = actionCreator('GET_ONBOARDING_ALL');

export const CLEAR_ONBOARDING_LIST = actionCreator('CLEAR_ONBOARDING_LIST');

export const GET_ONBOARDING_BY_ID = actionCreator('GET_ONBOARDING_BY_ID');

export const DELETE_ONBOARDING = actionCreator('DELETE_ONBOARDING');

export const GET_ONBOARDING_FORMS = actionCreator('GET_ONBOARDING_FORMS');

export const GET_ONBOARDING_TEMPLATES = actionCreator('GET_ONBOARDING_TEMPLATES');

export const GET_ONBOARDING_FORM_BY_ID = actionCreator('GET_ONBOARDING_FORM_BY_ID');

export const CLEAR_ONBOARDING_FORM_BY_ID = actionCreator('CLEAR_ONBOARDING_FORM_BY_ID');

export const CLEAR_ONBOARDING_SUBMISSION = actionCreator('CLEAR_ONBOARDING_SUBMISSION');

export const CREATE_ONBOARDING_SUBMISSION = actionCreator('CREATE_ONBOARDING_SUBMISSION');

export const UPDATE_ONBOARDING_SUBMISSION = actionCreator('UPDATE_ONBOARDING_SUBMISSION');

export const CLE_ONBOARDING_SUBMISSION = actionCreator('CLE_ONBOARDING_SUBMISSION');

export const START_ONBOARDING_EDIT = actionCreator('START_ONBOARDING_EDIT');

export const STOP_ONBOARDING_EDIT = actionCreator('STOP_ONBOARDING_EDIT');

export const UPLOAD_ONBOARDING_DOCUMENT = actionCreator('UPLOAD_ONBOARDING_DOCUMENT');

export const UPDATE_ONBOARDING_DOCUMENT = actionCreator('UPDATE_ONBOARDING_DOCUMENT');

export const DELETE_ONBOARDING_DOCUMENT = actionCreator('DELETE_ONBOARDING_DOCUMENT');

export const DELETE_ATTACHED_DOCUMENTS = actionCreator('DELETE_ATTACHED_DOCUMENTS');

export const CREATE_FORM_INPUT_ELEMENT = actionCreator('CREATE_FORM_INPUT_ELEMENT');

export const EDIT_FORM_INPUT_ELEMENT = actionCreator('EDIT_FORM_INPUT_ELEMENT');

export const DELETE_FORM_INPUT_ELEMENT = actionCreator('DELETE_FORM_INPUT_ELEMENT');

export const CREATE_COMPOSITE_INPUT_ELEMENT = actionCreator('CREATE_COMPOSITE_INPUT_ELEMENT');

export const EDIT_COMPOSITE_INPUT_ELEMENT = actionCreator('EDIT_COMPOSITE_INPUT_ELEMENT');

export const DELETE_COMPOSITE_INPUT_ELEMENT = actionCreator('DELETE_COMPOSITE_INPUT_ELEMENT');

export const CREATE_FORM_ACTION_ELEMENT = actionCreator('CREATE_FORM_ACTION_ELEMENT');

export const SUBMIT_ONBOARDING = actionCreator('SUBMIT_ONBOARDING');

export const CANCEL_ONBOARDING = actionCreator('CANCEL_ONBOARDING');

export const GET_DIRECTORY = actionCreator('GET_DIRECTORY');

